export default function isUndefined(value: unknown): value is undefined {
  return value === undefined;
}
